import { Component, OnInit } from '@angular/core';
import { SharedService } from './shared/services/shared.service';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { UserroleService } from './utility/userrole.service';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { AuthenticationService } from './core/services/authentication.service';

export const defaultDateFormat: string = 'YYYY-MM-DD HH:mm:ss';
export const defaultDateFormatToDisplay: string = 'YYYY-MM-DD HH:mm';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'SFTPAdminGUI';
  user = '';
  error = '';

  constructor(
    private authenticationService: AuthenticationService,
    private shareddata: SharedService,
    private messageService: MessageService,
    private userservice: UserroleService,
    private dialogService: DialogService,
    private config: PrimeNGConfig,
    private router: Router
  ) {
  }
  ngOnInit() {
    this.authenticationService.getRoleForUser().then((currentRole) => {
    console.log('Application initiated');
    this.config.setTranslation({
      matchAll: 'Find regler, hvor alle specifikationer er opfyldt',
      matchAny: 'Find regler, hvor minimum en specifikation er opfyldt',
      dateIs: 'Dato er',
      dateIsNot: 'Dato er ikke',
      dateBefore: 'Dato er f�r',
      dateAfter: 'Dato er efter',
      addRule: 'Tilf�j regel',
      clear: 'Nulstil',
      apply: 'Vis resultat',
      removeRule: 'Slet regel',

      //Danish days and months for calendar component
      dayNames: [
        'S�ndag',
        'Mandag',
        'Tirsdag',
        'Onsdag',
        'Torsdag',
        'Fredag',
        'L�rdag',
      ],
      dayNamesShort: ['S�n', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'L�r'],
      dayNamesMin: ['S�', 'Ma', 'Ti', 'On', 'To', 'Fr', 'L�'],
      monthNames: [
        'Januar',
        'Februar',
        'Marts',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'December',
      ],
      monthNamesShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Maj',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dec',
      ],
    });
    let currentUser = this.authenticationService.getCurrentUser();
    let appRole = this.authenticationService.getAppRole();

    if (
      currentUser.roles.length === 0 ||
      appRole === undefined || appRole === 'none'
    ) {
      console.log('User logged in without any roles, routing to error page.');
      this.error = 'noroles';
      this.router.navigateByUrl('/error/noroles');
      return;
    }
    if(appRole === 'undefined') {
	  if (currentUser.roles.indexOf('route_administrator') >= 0 ||
          currentUser.roles.indexOf('route_supporter') >= 0) {
	    console.log('User logged in without any organisation, routing to error page.');
	    this.error = 'noorganisation';
	    this.router.navigateByUrl('/error/noorganisation');
	    return;
	  } else {
        console.log('User logged in without any roles, routing to error page.');
        this.error = 'noroles';
        this.router.navigateByUrl('/error/noroles');
        return;
      }
    }
    if (currentUser.isKombitAdmin && currentUser.roles.length > 1) {
      console.log(
        'User logged in as KOMBIT administrator and one or more ' +
          'additional roles, routing to error page.'
      );
      this.error = 'admrolesetup';
      this.router.navigateByUrl('/error/admrolesetup');
      return;
    }

    if (currentUser.isKombitSupporter && currentUser.roles.length > 1) {
      console.log(
        'User logged in as KOMBIT supporter and one or more additional roles, routing to error page.'
      );
      this.error = 'suprolesetup';
      this.router.navigateByUrl('/error/suprolesetup');
      return;
    }

     //CR183 FK-11 User’s consent for registraion.
     if(currentRole == "ACCEPTED")
     {
       this.router.navigate(['routes']);
     }
     else if(currentRole == "REJECTED" || currentRole == "EXPIRED" || currentRole == "NEW_TERMS")
     {
       this.error = 'acceptTerms';
       this.router.navigateByUrl('/error/acceptTerms');
       this.openDialog();
     }
     else{
       this.error = 'serverdown';
       this.router.navigateByUrl('/error/serverdown');
     }

    })
    .catch((error) => {
      console.error('Error occurred:', error);
      this.error = 'serverdown';
      this.router.navigateByUrl('/error/serverdown');
      // Handle any errors that might occur during the API call
    });
  }

   //CR183 FK-11 User’s consent for registraion.
   openDialog()
   {
     const ref =this.dialogService.open(ConsentDialogComponent,{
       header: "Accepter vilkår og betingelser",
       closable: false,
     })
 
     ref.onClose.subscribe((result: {result :string})=>{
      if(result.result == "REJECTED")
      {
        this.error = 'noAcceptedTerms';
        this.router.navigateByUrl('/error/noAcceptedTerms');
      }
      else if(result.result == "ACCEPTED")
      {
        this.error = '';
        this.router.navigate(['routes']);
      }
      else{
        this.error = 'serverdown';
        this.router.navigateByUrl('/error/serverdown');
      }
    })
   }
}